import _ from 'lodash';

export const prepareCartItem = (catalog, itemId) => {
    const menuItem = catalog.items[itemId];

    const cartItem = { id: itemId, selections: {}, remarks: '' };

    menuItem.subcategories.forEach(sub => {
        const preSelections = sub.items.filter(i => i.meta && i.meta.preSelected);
        if (preSelections.length) {
            cartItem.selections[sub.id] = preSelections.map(item => prepareCartItem(catalog, item.id));
        }
    });

    return cartItem;
};

export const getItemSelectionGroups = (catalog, cartItem) => {
    const menuItem = catalog.items[cartItem.id];

    return menuItem.subcategories;
};

export const calcCartItemPrice = (catalog, cartItem) => {
    const price = cartItem.price == null ? catalog.items[cartItem.id].price : cartItem.price;

    return Object.values(cartItem.selections || {}).reduce((finalPrice, items) => {
        return items.reduce((total, item) => total + calcCartItemPrice(catalog, item), finalPrice);
    }, price);
};

export const validateCartItem = (catalog, cartItem) => {
    const menuItem = catalog.items[cartItem.id];

    return (menuItem.mandatories || []).find(cat => (cartItem.selections[cat.id] || []).length === 0);
};

export const updateItemSelections = (catalog, parantItem, selection) => {
    const { ...selections } = parantItem.selections;
    const selectionCategory = catalog.categories[selection.categoryId];

    let currentSelection = selections[selectionCategory.id] || [];

    const isPizzaBuilder = selectionCategory.options.builderType === 'pizza';

    if (selection.amount < 0) {
        if (selectionCategory.type === 'addon') {
            let { amount } = selection;
            currentSelection = currentSelection.filter(s => {
                if (s.id === selection.cartItem.id && amount) {
                    amount++;
                    return false;
                }
                return true;
            });
        }
    } else if (selection.amount > 0) {
        if (isPizzaBuilder) {
            currentSelection = currentSelection.filter(s => catalog.items[s.id].extra.itemId !== catalog.items[selection.cartItem.id].extra.itemId);
        }

        currentSelection = currentSelection.concat(Array(selection.amount).fill(selection.cartItem));

        const selectionsCount = isPizzaBuilder ?
            currentSelection.reduce((count, s) => count + (catalog.items[s.id].meta.pizzaCover > 0 ? 0.5 : 1), 0) :
            currentSelection.length;

        const limit = selectionCategory.type === 'mandatory' ? 1 : selectionCategory.limit;

        if (limit && selectionsCount > limit) {
            currentSelection.splice(0, currentSelection.length - limit);
        }
    }

    const { deal } = selectionCategory.options;

    if (deal) {
        if (deal.dealType === 'freeSelection') {
            currentSelection
                .concat()
                .map((s, index) => ({ ...catalog.items[s.id], index }))
                .sort((i1, i2) => isPizzaBuilder ? i1.meta.pizzaCover - i2.meta.pizzaCover : i1.price - i2.price)
                .reduce((amount, item) => {
                    if (amount > 0) {
                        amount -= item.meta && item.meta.pizzaCover ? 0.5 : 1;
                        currentSelection[item.index].price = 0;
                    } else {
                        delete currentSelection[item.index].price;
                    }
                    return amount;
                }, deal.amount || 1);
        }
    }

    selections[selectionCategory.id] = currentSelection;
    return selections;
};

export const prepareMenuForOrdering = (catalog, options) => {
    const { orderType, customerType, spreadCategoriesParents } = options;
    const categories = _.cloneDeep(catalog.categories || {});
    const items = _.cloneDeep(catalog.items || {});
    const translations = options.translations;

    let hierarchy = [];

    Object.keys(categories).forEach(catId => {
        const category = categories[catId];

        if (translations) {
            category.name = translations[category.name] || category.name;
            category.description = translations[category.description] || category.description;
        }

        category.items = category.itemsInstances.map(({ id }) => items[id]).filter(item => checkTypes(item, orderType, customerType));

        if (category.type === 'primary') {
            if (category.primaryParentId) {
                if (categories[category.primaryParentId]) {
                    if (!categories[category.primaryParentId].categories) {
                        categories[category.primaryParentId].isPrimaryParent = true;
                        categories[category.primaryParentId].categories = [];
                    }
                    categories[category.primaryParentId].categories.push(category);
                }
            } else {
                hierarchy.push(category);
            }
        }
    });

    Object.keys(items).forEach(itemId => {
        const item = items[itemId];

        if (translations) {
            item.name = translations[item.name] || item.name;
            item.description = translations[item.description] || item.description;
        }

        item.mandatories = [];
        item.optionals = [];
        item.subcategories = [];

        item.subcategoriesIds.forEach(subId => {
            const subcategory = categories[subId];

            if (validateCategory(subcategory)) {
                item[subcategory.type === 'mandatory' ? 'mandatories' : 'optionals'].push(subcategory);
                item.subcategories.push(subcategory);
            }
        });

        item.priceBeforeChange = item.price;
        item.originalPrice = item.extra.originalPrice;

        item.meta = item.extra.meta;
        item.itemId = item.extra.itemId;

        item.isComplex = !!item.subcategories.length;
    });

    function validateCategory(category) {
        if (!checkTypes(category, orderType, customerType)) return false;

        if (category.categories) {
            category.categories = category.categories.filter(validateCategory);
            category.categories.sort((a, b) => a.sortIndex - b.sortIndex);
        }

        return (category.items || []).length + (category.categories || []).length > 0;
    }

    hierarchy = hierarchy.filter(validateCategory).sort((a, b) => a.sortIndex - b.sortIndex);
    if (spreadCategoriesParents) {
        hierarchy = spreadParantCategories(hierarchy);
    }

    return {
        catalog: {
            categories,
            items
        },
        hierarchy,
    };
};

function spreadParantCategories(categories) {
    return categories.reduce((spreaded, category) => {
        if (category.isPrimaryParent) {
            return spreaded.concat(spreadParantCategories(category.categories));
        }
        return spreaded.concat(category);
    }, []);
}

export const checkTypes = (entity, orderType, customerType) => {
    if (!entity) return false;

    if (orderType) {
        if (entity.options.supportedFor && !entity.options.supportedFor.includes(orderType)) {
            return false;
        }
    }

    if (customerType) {
        if (entity.options.supportedCustomerTypes && !entity.options.supportedCustomerTypes.includes(customerType)) {
            return false;
        }
    }

    return true;
};
